export default "__VITE_ASSET__CdkyOu4t__"